<script lang="ts">import { Button } from "@infinitro/button";
import { cfgBrandTitle, cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, ModalDialog, pushModal } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const BRAND_NAME = cfgBrandTitle();
const bgSrc = cfgToThemeCdnPath("/about-vip/modern/hero-bg.png");
const ranksMobileSrc = cfgToThemeCdnPath("/about-vip/modern/hero-ranks-mobile.png");
const ranksDesktopSrc = cfgToThemeCdnPath("/about-vip/modern/hero-ranks.png");
const ranksSrc = $derived($isMobile ? ranksMobileSrc : ranksDesktopSrc);
const heroGlowSize = $derived($isMobile ? "150%" : "50%");
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
</script>

<InfoCard
	modernStyle
	modernBordered={false}
	modernGlowPosition="left"
	modernGlowSize={heroGlowSize}
	width="100%"
	noPadding
	borderRadius="20px"
	customClass="vip-hero-card"
>
	<div class="vip-hero">
		<img class="vip-hero-bg" src={bgSrc} alt={$t(Verbiage.illustration_alt, 'alts')} />

		<div class="vip-hero-content">
			<div class="vip-hero-eyebrow-wrap">
				<VipModernEyebrow text={$t(Verbiage.vip_modern_youre_probably_wondering)} />
			</div>
			<div class="vip-hero-copy">
				<Text
					type="title"
					titleSize="h4"
					titleWeight="extrabold"
					textColor="white"
					className="vip-hero-title"
				>
					{$t(Verbiage.vip_modern_hero_title).replace('[BRAND]', BRAND_NAME)}
				</Text>
				<Text type="body" bodySize="large" className="vip-hero-subtitle">
					{$t(Verbiage.vip_modern_hero_body)}
				</Text>
			</div>
			<Button
				text={$t(Verbiage.vip_modern_register_cta)}
				variant="primary"
				minWidth
				fullWidthMobile
				onClick={handleSignup}
			/>
		</div>

		<img class="vip-hero-ranks" src={ranksSrc} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
	</div>
</InfoCard>

<style>
	:global(.vip-hero-card) {
		min-height: 520px;
		height: auto;
	}

	@media (min-width: 1024px) {
		:global(.vip-hero-card) {
			aspect-ratio: 1200 / 575;
			min-height: 575px;
		}
	}

	.vip-hero {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		align-items: center;
}

	.vip-hero-bg {
		position: absolute;
		top: 180px;
		height: auto;
		width: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
}

	.vip-hero-content {
		position: relative;
		z-index: 1;
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 2.5rem;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		padding-top: 3rem;
}

	.vip-hero-copy {
		display: flex;
		flex-direction: column;
		gap: 1rem;
}

	.vip-hero-eyebrow-wrap :global(.vip-modern-eyebrow) {
		margin-left: auto;
		margin-right: auto;
		display: block;
		width: -moz-fit-content;
		width: fit-content;
		text-align: center;
}

	:global(.vip-hero-title) {
		max-width: 28rem;
		font-size: 40px !important;
		font-weight: 700 !important;
		line-height: 120% !important;
		letter-spacing: -0.02em !important;
		white-space: pre-line;
	}

	:global(.vip-hero-subtitle) {
		max-width: 26rem;
	}

	.vip-hero-ranks {
		position: relative;
		z-index: 1;
		margin-top: 2rem;
		margin-bottom: 2rem;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
}

	@media (min-width: 1024px) {
		.vip-hero-content {
				align-items: center;
				padding-top: 3.5rem;
				text-align: center;
		}

		.vip-hero-copy {
				align-items: center;
		}

		.vip-hero-eyebrow-wrap {
				width: auto;
		}

		.vip-hero-eyebrow-wrap :global(.vip-modern-eyebrow) {
				display: inline-block;
				width: auto;
		}

		:global(.vip-hero-title) {
			max-width: 40rem;
			text-align: center !important;
			font-size: 37px !important;
			white-space: normal;
		}

		:global(.vip-hero-subtitle) {
			max-width: 34rem;
			text-align: center !important;
		}

		.vip-hero-ranks {
				margin-top: auto;
				margin-bottom: 2rem;
		}

		.vip-hero-bg {
				inset: 0px;
		}
	}
</style>
